import { PageShell } from "./PageShell";
import { Audience } from "./Audience";
import { FinalCTA } from "./FinalCTA";

export default function AudiencePage() {
  return (
    <PageShell testId="audience-page">
      <div className="pt-[72px]">
        <Audience />
      </div>
      <FinalCTA />
    </PageShell>
  );
}
